import SqFetch from 'typescript/application/sq_fetch';
import { _handleResponse } from 'typescript/clients/utilities/handle_http_response';
import { CountryCode, LanguageCode } from 'typescript/constants/localization';
import {
  ListPaymentOptionsResponse,
  PaymentScheduleNoInstallment,
} from 'typescript/types/api/payment_options';
import { _urlContext } from 'typescript/clients/utilities/common';

// functions are controlled by the methods in this controller
// app/controllers/sq/api/checkout/payment_options_controller.rb

export const LIST_PAYMENT_OPTIONS_BASE_URL =
  '/shop/api/v1/checkout/payment_options/list';
export const SELECT_PAYMENT_OPTIONS_URL =
  '/shop/api/v1/checkout/payment_options/select';

/**
 * List payment options
 * @returns payment options for the current order
 */
export const listPaymentOptions = async ({
  orderNumber,
  countryCode,
  languageCode,
}: {
  orderNumber: string;
  countryCode: CountryCode;
  languageCode: LanguageCode;
}): Promise<ListPaymentOptionsResponse> => {
  const response = await SqFetch.get(
    `${LIST_PAYMENT_OPTIONS_BASE_URL}${_urlContext({
      countryCode,
      languageCode,
      orderNumber,
    })}`,
  );

  return _handleResponse(response);
};

/**
 * Select payment option for on order. NOTE: The offer_select endpoint
 * is used for selecting installment.
 * @returns success or error message
 */
export const selectPaymentOption = async ({
  languageCode,
  orderNumber,
  paymentOption,
  countryCode,
}: {
  languageCode: LanguageCode;
  orderNumber: string;
  paymentOption: PaymentScheduleNoInstallment;
  countryCode: CountryCode;
}): Promise<{ success: boolean }> => {
  const response = await SqFetch.post(SELECT_PAYMENT_OPTIONS_URL, {
    language_code: languageCode,
    order_number: orderNumber,
    payment_option: paymentOption,
    store_code: countryCode,
  });

  return _handleResponse(response);
};
